var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.478 10.393C24.472 10.366 24.472 10.337 24.461 10.311C24.435 10.248 24.397 10.192 24.35 10.144L22.5 8.294V4.5C22.5 3.122 21.378 2 20 2H5C3.622 2 2.5 3.122 2.5 4.5V8.293L0.646 10.147C0.642 10.151 0.641 10.157 0.636 10.161C0.596 10.204 0.561 10.253 0.538 10.308C0.513 10.371 0.5 10.436 0.5 10.502V21.5C0.5 22.327 1.173 23 2 23H23C23.827 23 24.5 22.327 24.5 21.5V10.5C24.5 10.462 24.486 10.428 24.478 10.393ZM22.5 9.708L22.792 10H22.5V9.708ZM3.5 4.5C3.5 3.673 4.173 3 5 3H20C20.827 3 21.5 3.673 21.5 4.5V8.499V8.502V10H3.5V4.5ZM2.5 9.707V10H2.207L2.5 9.707ZM23.5 21.5C23.5 21.776 23.276 22 23 22H2C1.724 22 1.5 21.776 1.5 21.5V11H23.5V21.5ZM9.5 16H15.5C16.603 16 17.5 15.103 17.5 14C17.5 12.897 16.603 12 15.5 12H9.5C8.397 12 7.5 12.897 7.5 14C7.5 15.103 8.397 16 9.5 16ZM9.5 13H15.5C16.051 13 16.5 13.449 16.5 14C16.5 14.551 16.051 15 15.5 15H9.5C8.949 15 8.5 14.551 8.5 14C8.5 13.449 8.949 13 9.5 13ZM19.743 4.071L13.786 7.645C12.993 8.122 12.007 8.122 11.214 7.645L5.257 4.071C5.019 3.929 4.713 4.005 4.571 4.242C4.429 4.479 4.505 4.786 4.742 4.928L10.699 8.502C11.255 8.835 11.877 9.002 12.5 9.002C13.123 9.002 13.746 8.836 14.301 8.502L20.258 4.928C20.494 4.786 20.571 4.478 20.429 4.242C20.287 4.006 19.981 3.929 19.743 4.071Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.5b2d6ab2edfa042ba158b605a2e8550e.svg";
export { ForwardRef as ReactComponent };